module.exports = __webpack_public_path__ + "static/media/JulianaPereira.3d0f96b5.png";